<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Discount Name"
                  v-model="discount.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="percentage"
                  label="Discount Percent"
                  v-model="discount.percentage"
                  type="text"
                  :rules="rules.percentageRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select 
                  name="discountType" 
                  label="Discount Type" 
                  :items="discountTypeList" 
                  v-model="discount.discountType" 
                  item-text="label" 
                  item-value="value" 
                  :rules="rules.discountTypeRules">
                </v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Discount Description"
                  v-model="discount.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="discount.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="discount.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="discount.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="discount.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="discount.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="discount.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="discount.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { discountService } from "../../services/discount-service";
import { Discount } from "../../models/model";
import { DiscountFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "DiscountDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Discount",
        disabled: false,
        to: "discounts"
      },
      {
        text: "Discounts Detail",
        disabled: true
      }
    ],
    discountTypeList: [
      { label: "Wholesale", value: "WHOLESALE" },
      { label: "Retail Sale", value: "RETAIL_SALE" }
    ],
    updatedDate: "",
    createdDate: "",
    discount: new Discount(),
    oldDiscount: new Discount(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new DiscountFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new discount
    } else {
      this.getDiscountDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.discount.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let discountObj = {
          id: this.discount.id ? this.discount.id : "",
          name: this.discount.name,
          percentage: this.discount.percentage,
          description: this.discount.description,
          status: this.discount.status,
          discountType: this.discount.discountType
        };
        discountService
          .saveDiscount(discountObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getDiscountDetail(id) {
      discountService
        .getDiscountDetail(id)
        .then(res => {
          this.discount = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.discount.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.discount.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldDiscount = Object.assign({}, res.data);
          this.statusFlag = this.discount.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.discount.id) {
        this.discount = new Discount();
        this.statusFlag = true;
      } else {
        this.discount = Object.assign({}, this.oldDiscount);
        this.statusFlag = this.discount.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/discounts");
    }
  }
};
</script>

